import React from 'react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'
import DragWrapper from 'designer/component/system/layout/control/DragWrapper'

import CustomComponent from 'designer/component/component'
import { Row } from 'react-bootstrap'

export const ComponentSystem = (props) => {
  let { uischema } = props
  return (
    <DragWrapper {...props} noPadding>
      <Row className="w-100 mx-0">
        <span className="ml-2 mr-1 font-weight-bold"> Component :</span>
        <span>{uischema?.fieldName}</span>
      </Row>
      <CustomComponent {...props} />
    </DragWrapper>
  )
}

export const ComponentDisplay = (props) => {
  return (
    <ComponentWrapper {...props}>
      <CustomComponent {...props} />
    </ComponentWrapper>
  )
}

export const componentTester = rankWith(3, and(scopeEndsWith('component')))
